import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { useDispatch } from "react-redux";
import { RaydiumOffchainResponse, RaydiumPositionExpanded } from "@bridgesplit/abf-sdk";
import { Connection } from "@solana/web3.js";
import { RPC_URL } from "@bridgesplit/utils";

import { ClaimableRaydiumFeeResult, getClaimableRaydiumFee } from "../api";
import { RaydiumPoolData, RaydiumPositionData } from "../types";

const RAYDIUM_TAG = "RaydiumList";
export const raydiumExternalApi = createApi({
    reducerPath: "raydiumExternalApi",
    tagTypes: [RAYDIUM_TAG],
    baseQuery: fetchBaseQuery({ baseUrl: "https://api-v3.raydium.io/" }),
    endpoints: (builder) => ({
        raydiumOffchain: builder.query<RaydiumOffchainResponse, { ids: string[] }>({
            providesTags: [RAYDIUM_TAG],
            query: ({ ids }) => ({
                url: "/pools/info/ids",
                method: "GET",
                params: { ids }
            })
        }),
        claimableFee: builder.query<
            ClaimableRaydiumFeeResult,
            {
                positionExpanded: RaydiumPositionExpanded;
                poolData: RaydiumPoolData;
                positionData: RaydiumPositionData;
            }
        >({
            async queryFn({ positionExpanded, poolData, positionData }) {
                const connection = new Connection(RPC_URL, "confirmed");
                const result = await getClaimableRaydiumFee(connection, positionExpanded, poolData, positionData);

                if (result.isErr()) {
                    return {
                        error: {
                            status: "CUSTOM_ERROR",
                            data: result.unwrapErrMessage(),
                            error: result.unwrapErrMessage()
                        }
                    };
                }

                return { data: result.unwrap() };
            },
            providesTags: [RAYDIUM_TAG]
        })
    })
});
export const { useRaydiumOffchainQuery, useClaimableFeeQuery } = raydiumExternalApi;

export function useRaydiumExternalApi() {
    const dispatch = useDispatch();
    return { resetRaydiumExternalApi: () => dispatch(raydiumExternalApi.util.invalidateTags([RAYDIUM_TAG])) };
}
